import type { Observable } from 'rxjs';

import { Injectable, InjectionToken, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { parseResponse } from '@integrations/shared/parse-response';
import {
    PaymentMethodCollectionResponseSchema,
    PaymentMethodOptionCollectionResponseSchema,
    type PaymentMethod,
    type PaymentMethodOption,
} from '../contracts/payment-method.contract';

export const PAYMENT_SERVICE_API_BASE = new InjectionToken<string>('PAYMENT_SERVICE_API_BASE', {
    providedIn: 'root',
    factory: () => '/api/payment-service',
});

@Injectable({ providedIn: 'root' })
export class PaymentMethodsApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(PAYMENT_SERVICE_API_BASE);

    public getPaymentMethods(): Observable<PaymentMethod[]> {
        return this.http.get<unknown>(`${this.baseUrl}/payment-methods`).pipe(
            map(
                (res) =>
                    parseResponse(res, PaymentMethodCollectionResponseSchema, {
                        endpoint: 'payment-methods',
                        method: 'GET',
                    }).data
            )
        );
    }

    public getPaymentMethodsOptions(): Observable<PaymentMethodOption[]> {
        return this.http.get<unknown>(`${this.baseUrl}/payment-methods/options`).pipe(
            map(
                (res) =>
                    parseResponse(res, PaymentMethodOptionCollectionResponseSchema, {
                        endpoint: 'payment-methods/options',
                        method: 'GET',
                    }).data
            )
        );
    }
}
